import XLSX from "xlsx";
import FileSaver from "file-saver";

export const exportToExcel = (data, header) => {
  const ws = XLSX.utils.book_new();
  XLSX.utils.sheet_add_aoa(ws, [header]);
  XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { type: 'array', cellStyles: true });
  const finalData = new Blob([excelBuffer]);
  FileSaver.saveAs(finalData, "Dimensions.xlsx");
};